import PropTypes from 'prop-types';
import { Collapse } from '@mantine/core';
import classes from './collapseBox.module.css';

const CollapseBox = (props) => {
  const {
    title,
    subtitle,
    children,
    open = false,
    avatar,
    actions = [],
    onClick,
  } = props;

  const actionsElements = actions.map((action, index) => (
    <div key={index} className={classes.action}>{action}</div>
  ));

  return (
    <div className={classes.box} onClick={onClick}>
      <div className={classes.head}>
        <div className={classes.info}>
          {avatar && <span className={classes.avatar}>{avatar}</span>}
          <span className={classes.text}>
            <div className={classes.title}>{title}</div>
            {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
          </span>
        </div>
        {!open && <div className={classes.actions}>{actionsElements}</div>}
      </div>
      <Collapse in={open}>
        <div className={classes.body}>{children}</div>
      </Collapse>
    </div>
  );
};

CollapseBox.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.any,
  open: PropTypes.bool,
  avatar: PropTypes.node,
  actions: PropTypes.array,
  onClick: PropTypes.func,
};

export default CollapseBox;
